import React, { Component } from 'react';
import './eventmanagement.css';
import { showNotification } from '../../StatusNotification';
import { showConfirmation } from '../../ConfirmationModal';

export class EventDeletion extends Component {
    static displayName = EventDeletion.name;

    constructor(props) {
        super(props);
        this.state = {
            events: [],
            toDelete: []
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    formatDateTime(dateTime, includeTime) {
        let timestamp = new Date(dateTime.toString());

        let year = timestamp.getFullYear();
        let month = timestamp.getMonth().toString().length === 1 ? '0' + (timestamp.getMonth() + 1).toString() : timestamp.getMonth() + 1;
        let date = timestamp.getDate().toString().length === 1 ? '0' + (timestamp.getDate()).toString() : timestamp.getDate();
        let hours = timestamp.getHours().toString().length === 1 ? '0' + timestamp.getHours().toString() : timestamp.getHours();
        let midday = hours >= 12 ? "PM" : "AM";
        if (hours == 0) {
            hours = 12;
        }
        if (hours >= 13) {
            hours = hours - 12;
            if (hours.toString().length === 1) hours = '0' + hours;
        }
        let minutes = timestamp.getMinutes().toString().length === 1 ? '0' + timestamp.getMinutes().toString() : timestamp.getMinutes();


        let timestampFormat = includeTime ?
            (month + "/" + date + "/" + year + " " + hours + ":" + minutes + " " + midday) :
            (month + "/" + date + "/" + year);

        return timestampFormat;
    }

    handleDeleteCheckboxChange = (e) => {
        const id = e.target.dataset.id;
        const isChecked = e.target.checked;

        this.setState(prevState => {
            let newToDelete = [...prevState.toDelete];

            if (isChecked) {
                // Add ID to array if not already present
                if (!newToDelete.includes(id)) {
                    newToDelete.push(id);
                }
            } else {
                // Remove ID from array
                const index = newToDelete.indexOf(id);
                if (index > -1) {
                    newToDelete.splice(index, 1);
                }
            }

            return { toDelete: newToDelete };
        });
    }

    deleteItems = async (e) => {
        e.preventDefault();

        if (this.state.toDelete.length === 0) {
            showNotification("Please select items to delete", "error");
            return;
        }

        let confirmDelete = await showConfirmation("Are you sure you want to delete the selected items?");
        if (!confirmDelete) {
            return;
        }

        let allSuccess = true;
        let errorMessages = [];

        for (let i = 0; i < this.state.toDelete.length; i++) {
            try {
                const response = await fetch('AdminEvent/DeleteEvent?eventId=' + this.state.toDelete[i], {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                });

                const data = await response.json();

                if (data !== "Deleted") {
                    allSuccess = false;
                    errorMessages.push(`Event ${this.state.toDelete[i]}: ${data}`);
                }
            } catch (error) {
                allSuccess = false;
                errorMessages.push(`Event ${this.state.toDelete[i]}: Network error`);
            }
        }

        if (allSuccess) {
            // Clear the selection and refresh the data
            this.setState({ toDelete: [] });
            this.getComponentData();
            showNotification("All events deleted successfully", "success");
        } else {
            showNotification("Some deletions failed:\n" + errorMessages.join("\n"), "error");
            // Still refresh to show current state
            this.setState({ toDelete: [] });
            this.getComponentData();
        }
    }

    render() {
        let events = this.state.events;
        let table = null;

        if (events.length > 0) {
            table = (
                <table>
                    <thead>
                        <tr>
                            <th>Select</th>
                            <th>Title</th>
                            <th>Url</th>
                            <th>Department</th>
                            <th>Start Time</th>
                            <th>Uploader</th>
                            <th>Timestamp</th>
                        </tr>
                    </thead>
                    <tbody>
                        {events.map((event, i) => {
                            if (event.status === "Deleted") return null;

                            //let timestamp = new Date(event.timestamp.toString());
                            //let timestampFormat = (timestamp.getMonth() + 1) + "/" + timestamp.getDate() + "/" + timestamp.getFullYear();

                            let startTimeFormat = this.formatDateTime(event.startTime, true);
                            let timestampFormat = this.formatDateTime(event.timestamp, false);

                            return (
                                <tr key={event.id || i}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            data-id={event.id}
                                            checked={this.state.toDelete.includes(event.id.toString())}
                                            onChange={this.handleDeleteCheckboxChange}
                                        />
                                    </td>
                                    <td>{event.title}</td>
                                    <td>{event.eventUrl}</td>
                                    <td>{event.types}</td>
                                    <td>{startTimeFormat}</td>
                                    <td>{event.uploader}</td>
                                    <td>{timestampFormat}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            );
        }

        return (
            <div className='event-management'>
                <div className='page-title'>
                    <h1>Event Deletion</h1>
                </div>

                <div className='table-container'>
                    <button onClick={this.deleteItems} className='form-management-button'>Delete Selected</button>
                    {table}
                </div>
            </div>
        );
    }

    async getComponentData() {
        const response = await fetch('AdminEvent/GetEvents', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            events: data
        });
    }
}